// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"e30d7142","18":"4935e72a","242":"6e9bf4e9","411":"f96439c4","667":"a056a90d","746":"47944726","807":"d36f4f47","827":"a95c3fca","845":"6c232d14","903":"ae502754"}[chunkId] + ".chunk.js";
};